import axios from "axios";
import { IWidgetResponse } from "../Base/Base.types";
import {IModeOfTransportationBreakdownByMonth} from "./ModeOfTransportationBreakdownByMonth.types";

export default class ModeOfTransportationBreakdownByMonthApi {
    static async getData({queryKey}: any) {
        //eslint-disable-next-line
        const [_, rawQuery] = queryKey;
        try {
            let res = await axios.get(`/ModeOfTransportationBreakdownByMonth`, {params: rawQuery});
            return res.data as IWidgetResponse<IModeOfTransportationBreakdownByMonth>;
        } catch (e: any) {
            console.error('Could not get ModeOfTransportationBreakdownByMonth data: ', e.message);
            return undefined;
        }
    }
}